import type { PhoneAlpha2 } from './types'
import type { Iso3166Alpha2 } from './locations'

// order is not significant to user--keep in ABC order here for maintenance
// This list is based on where Twilio can send SMS and where we want to send
// When adding any new codes ensure our useLocation handles it
// and ensure the phone number has the mapping to the alpha3 code.
// For now we will keep this as a whitelist and expand as needed.
// Taking the intersection of PhoneAlpha2 and Iso3166Alpha2 to ensure these locations have full support within the codebase
const supportedCallingLocations: (PhoneAlpha2 & Iso3166Alpha2)[] = [
  'AD',
  'AE',
  'AL',
  'AM',
  'AO',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'BB',
  'BE',
  'BG',
  'BI',
  'BJ',
  'BM',
  'BO',
  'BR',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CD',
  'CG',
  'CH',
  'CI',
  'CL',
  'CN',
  'CO',
  'CR',
  'CV',
  'CZ',
  'DE',
  'DK',
  'DO',
  'EC',
  'EE',
  'EG',
  'ES',
  'FI',
  'FJ',
  'FR',
  'GB',
  'GD',
  'GE',
  'GH',
  'GP',
  'GT',
  'GU',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KH',
  'KI',
  'KR',
  'KW',
  'KZ',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'MA',
  'MD',
  'MG',
  'MN',
  'MO',
  'MT',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NG',
  'NI',
  'NL',
  'NO',
  'NZ',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PR',
  'PT',
  'PY',
  'QA',
  'RO',
  'RU',
  'SE',
  'SG',
  'SK',
  'SL',
  'SV',
  'SZ',
  'TG',
  'TH',
  'TO',
  'TR',
  'TT',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'VE',
  'VI',
  'VN',
  'VU',
  'WS',
  'ZA',
  'ZM',
  'ZW',
]

export default supportedCallingLocations
